import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function LeadersAgenda() {
  return (
    <BackgroundWrapper>
      
      <div className="pt-8 pb-20 px-4 min-h-screen flex justify-center">
        <div className="max-w-5xl bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12">
          <Link
            to="/programs"
            className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold"
          >
            ← Back to Programs
          </Link>

          <h1 className="text-xl sm:text-2xl font-bold text-slate-800 mb-8 text-center">
            The Leader’s Agenda
          </h1>

          <p className="sm:text-lg text-sm text-slate-700 mb-6 leading-relaxed">
            A program designed to help <strong>senior executives transition into new leadership roles</strong>.
            It supports leaders as they align their personal style, priorities, and strategic vision
            with their organizational context.
          </p>

          <h3 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4 ">The Content</h3>
          <ul className="list-disc list-inside text-slate-700 mb-6 space-y-1 sm:text-lg text-sm">
            <li>Determine personal leadership traits and identify development gaps</li>
            <li>Align persona and leadership style with organizational needs</li>
            <li>Develop leader’s priorities and a 100-day strategic plan</li>
          </ul>

          <h3 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">The Format</h3>
          <p className="text-slate-700 mb-6 sm:text-lg text-sm">
            Delivered through <strong>individual coaching and mentoring</strong> sessions,
            accredited and recognized internationally.
          </p>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
